var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM6.53431 5.83859C6.33944 5.7036 6.07001 5.72288 5.89645 5.89645L5.83859 5.96569C5.7036 6.16056 5.72288 6.42999 5.89645 6.60355L7.293 8L5.89645 9.39645L5.83859 9.46569C5.7036 9.66056 5.72288 9.92999 5.89645 10.1036L5.96569 10.1614C6.16056 10.2964 6.42999 10.2771 6.60355 10.1036L8 8.707L9.39645 10.1036L9.46569 10.1614C9.66056 10.2964 9.92999 10.2771 10.1036 10.1036L10.1614 10.0343C10.2964 9.83944 10.2771 9.57001 10.1036 9.39645L8.707 8L10.1036 6.60355L10.1614 6.53431C10.2964 6.33944 10.2771 6.07001 10.1036 5.89645L10.0343 5.83859C9.83944 5.7036 9.57001 5.72288 9.39645 5.89645L8 7.293L6.60355 5.89645L6.53431 5.83859Z",
    fill: "#9A1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/Offline.143a572dd6e4f3d0b74bdc0ecae799be.svg";
export { ForwardRef as ReactComponent };